import React, { useContext } from "react";
import { Global } from "../../App";
import Tool_counter from "./Tool_counter";
import { FormattedMessage } from "react-intl";
import { CusSwitch } from "../From/Switch";
import _ from "lodash";
import cls from "classnames";

/**
 *
 * @param {object} props
 * @param {string} props.type
 * @param {string} props.device
 * @param {object} props.data
 * @param {()=>data} props.onDelete
 * @param {()=>data} props.onUpdate
 * @param {()=>data} props.onEditTaste
 * @param {()=>data} props.onAddNewSpec
 *
 *
 */

// 規格component
function Tool_mealListWithoutSplit_staff({
  user = "staff",
  readOnly = false,
  device,
  data,
  onDelete,
  onUpdate,
  onEditTaste,
  onAddNewSpec,
}) {
  // function totalPrice(originalPrice, quantity, extraPrice) {
  //   return originalPrice * quantity + extraPrice() * quantity;
  // }
  // [外帶]開啟特口選單
  const { globalState, dispatchGlobal } = useContext(Global);
  const addTakeoutWithTaste = (specDate) => {
    onAddNewSpec({
      hasSpecTaste: true,
      specPopupSetting: {
        toggle: true,
        productName: data.name,
        specName: specDate.name,
        itemList: data.takeoutTaste,
        selectedItem: data.takeoutTaste
          .filter((f) => f.preset)
          .map((e) => e.id),
      },
      isAddNew: true,
      currModify: {
        specId: specDate.id,
        takeout: true,
        taste: data.takeoutTaste.filter((f) => f.preset).map((e) => e.id),
        quantity: 1,
      },
    });
  };
  // [外帶]直接新增一筆預設特口
  const addTakeoutDefault = (specDate) => {
    onAddNewSpec({
      hasSpecTaste: false,
      currModify: {
        specId: specDate.id,
        takeout: true,
        taste: [],
        quantity: 1,
      },
    });
  };
  // [內用]開啟特口選單
  const addDiningInWithTaste = (specDate) => {
    onAddNewSpec({
      hasSpecTaste: true,
      specPopupSetting: {
        toggle: true,
        productName: data.name,
        specName: specDate.name,
        itemList: data.stayInTaste,
        selectedItem: data.stayInTaste.filter((f) => f.preset).map((e) => e.id),
      },
      isAddNew: true,
      currModify: {
        specId: specDate.id,
        takeout: false,
        taste: data.stayInTaste.filter((f) => f.preset).map((e) => e.id),
        quantity: 1,
      },
    });
  };
  // [內用]直接新增一筆預設特口
  const addDineInDefault = (specDate) => {
    onAddNewSpec({
      hasSpecTaste: false,
      currModify: {
        specId: specDate.id,
        takeout: false,
        taste: [],
        quantity: 1,
      },
    });
  };
  const showDineInIcon = (user, device) => {
    if (user === "staff" && device === "pc") {
      return "btn_o_require_white__pc";
    } else if (user === "staff" && device !== "pc") {
      return "btn_o_require_white__mobile";
    } else if (user === "customer" && device === "pc") {
      return "btn_o_dinein_white__pc";
    } else if (user === "customer" && device !== "pc") {
      return "btn_o_dinein_white__mobile";
    }
  };
  const convertBArray = (n) =>{
    let transValue =  Number(n);   
    let array = (transValue+'').split('').map(Number);
    let newArray = [];
    let added = 1;
    array.forEach((i) => {
      newArray.push((i*added).toString());
      added = added*10;
    });
    return newArray;
  };

  if (!data) return null;
  else if(globalState.customer.filterVegan && globalState.customer.filterVegan.length > 0){
    let veganType = globalState.customer.veganTags.filter(t=>t.id===globalState.customer.filterVegan[0]).map(e=>e.isVegan);
    let veganTypeBArray = convertBArray(Number(veganType).toString(2));
    data.specification = data.specification.filter(i=>{             
      if(data.specification.some(s=>s.veganType !== null)){ 
        return (veganTypeBArray.includes(Number(i.veganType).toString(2))); 
      }
      else{
        return true;
      }                      
    })
  }
  return (
    <div className="Pages__specification mb-3">
      {data.specification.map((eachSpec, specIndex) => (
        <div key={specIndex} className="mb-3">
          <div
            className={cls(
              "Pages__specification__header d-flex justify-content-between align-items-center p-2 pr-3 pl-3 ",
              eachSpec.status === 3 || eachSpec.status === 4 ? "isSoldOut" : ""
            )}
          >
            <p className="m-0">
              <span className="mr-2">{eachSpec.name}</span>
              <span translate="no" className="mr-2">$ {eachSpec.price}</span>
            </p>
            {eachSpec.status === 3 || eachSpec.status === 4 ? (
              // 售畢
              <div className="d-flex">
                <div
                  className={
                    device === "pc"
                      ? "btn_o_no_icon__pc"
                      : "btn_o_no_icon__mobile"
                  }
                ></div>
                <div className="d-flex align-items-center addmeal-text">
                  <FormattedMessage
                    id={`popup.${
                      eachSpec.status === 3 ? "soldOut" : "suspendSell"
                    }`}
                  />
                </div>
              </div>
            ) : readOnly ? (
              <div
                className={
                  device === "pc"
                    ? "btn_o_no_icon__pc"
                    : "btn_o_no_icon__mobile"
                }
              ></div>
            ) : (
              // 新增
              <div className="d-flex">
                {/* 新增外帶組合 */}
                <div>
                  {/* <a
                  className={cls(
                    'icn ml-2',
                    device === 'pc'
                      ? 'btn_o_takeout_white__pc'
                      : 'btn_o_takeout_white__mobile'
                  )}
                  onClick={() => {
                    let isTasteExist = data.takeoutTaste.length > 0;
                    // 新增外帶時可以選擇特口
                    if (isTasteExist && user === 'staff') {
                      addTakeoutWithTaste(eachSpec);
                    }
                    // 新增外帶時不能選擇特口
                    else {
                      addTakeoutDefault(eachSpec);
                    }
                  }}
                /> */}
                </div>
                {/* 新增內用組合 */}
                <div>
                  {/* <a
                  className={cls('icn ml-2', showDineInIcon(user, device))}
                  onClick={() => {
                    let isTasteExist = data.stayInTaste.length > 0;
                    // 新增外帶時可以選擇特口
                    if (isTasteExist && user === 'staff') {
                      addDiningInWithTaste(eachSpec);
                    } // 新增外帶時不能選擇特口
                    else {
                      addDineInDefault(eachSpec);
                    }
                  }}
                /> */}
                </div>
                <a
                  className={cls(
                    "icn ml-2",
                    device === "pc"
                      ? "btn_o_addmeal__pc"
                      : "btn_o_addmeal__mobile"
                  )}
                  onClick={() => {
                    onAddNewSpec({
                      hasSpecTaste: true,
                      specPopupSetting: {
                        toggle: true,
                        productName: data.name,
                        specName: eachSpec.name,
                        dineInTaste: data.stayInTaste,
                        takeoutTaste: data.takeoutTaste,
                        disableTakeoutState: false,
                        applyMode: eachSpec.applyMode,
                      },
                      isAddNew: true,
                      currModify: {
                        specId: eachSpec.id,
                        takeout: false,
                        taste: data.stayInTaste
                          .filter((f) => f.preset)
                          .map((e) => e.id),
                        quantity: 1,
                      },
                    });
                  }}
                />
                <div
                  className="d-flex align-items-center addmeal-text"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    onAddNewSpec({
                      hasSpecTaste: true,
                      specPopupSetting: {
                        toggle: true,
                        productName: data.name,
                        specName: eachSpec.name,
                        dineInTaste: data.stayInTaste,
                        takeoutTaste: data.takeoutTaste,
                        disableTakeoutState: false,
                        applyMode: eachSpec.applyMode,
                      },
                      isAddNew: true,
                      currModify: {
                        specId: eachSpec.id,
                        takeout: false,
                        taste: data.stayInTaste
                          .filter((f) => f.preset)
                          .map((e) => e.id),
                        quantity: 1,
                      },
                    });
                  }}
                >
                  <FormattedMessage id="popup.addMeal" />
                </div>
              </div>
            )}
          </div>
          {
            // 特口的組合
            eachSpec.combination.map((eachCombi, combiIndex) => (
              <>
                {((eachSpec.status === 3 || eachSpec.status === 4) &&
                  eachCombi.quantity === 0) ||
                readOnly ? null : (
                  <div
                    key={combiIndex}
                    className="Pages__specification__content pr-3 pl-3"
                  >
                    <div className="Pages__specification__item">
                      {device === "pc" ? (
                        <>
                          <div className="d-flex align-items-center pt-2 pb-2">
                            {/* <div className="d-flex align-items-center col p-0 pr-4" style={{ visibility: `${user === 'staff' ? 'visible' : 'hidden'}` }}> */}
                            <div className="d-flex align-items-center col p-0 pr-4">
                              {/* 刪除組合按鈕 */}
                              <div>
                                {/* 當組合超過一個的時候 => 顯示刪除按鈕 */}
                                {/* 當售完且數量不為零的時候 => 顯示刪除按紐 */}
                                {(eachSpec.combination.length !== 1 &&
                                  user === "staff") ||
                                ((eachSpec.status === 3 ||
                                  eachSpec.status === 4) &&
                                  eachCombi.quantity !== 0) ? (
                                  <a
                                    className="icn ic_order_remove__mobile"
                                    onClick={() => {
                                      let newState = _.cloneDeep(data);
                                      newState.specification[
                                        specIndex
                                      ].combination.splice(combiIndex, 1);
                                      onDelete({
                                        newData: newState,
                                      });
                                    }}
                                  />
                                ) : null}
                              </div>
                              {/* 顯示特口 */}
                              <span className="pr-2 pl-2">
                                {
                                  // 當組合不可設定特口 => 隱藏特口顯示
                                  (() => {
                                    return (
                                      <span className="mr-1 d-flex flex-wrap">
                                        {eachCombi.taste.map(
                                          (taste, tasteIndex) => {
                                            let whichTaste;
                                            if (eachCombi.takeout) {
                                              whichTaste = data.takeoutTaste;
                                            } else {
                                              whichTaste = data.stayInTaste;
                                            }
                                            return whichTaste
                                              .filter((tasteData) => {
                                                return tasteData.id === taste;
                                              })
                                              .map((e, index) => (
                                                <div
                                                  key={index}
                                                  className="text-nowrap"
                                                >
                                                  {(() => {
                                                    let hasPrice = e.price > 0;
                                                    let isLast =
                                                      eachCombi.taste.length ===
                                                      tasteIndex + 1;
                                                    return (
                                                      <>
                                                        <span>
                                                          {hasPrice
                                                            ? `${e.name}($+${e.price})`
                                                            : `${e.name}`}
                                                        </span>
                                                        {isLast ? (
                                                          ""
                                                        ) : (
                                                          <span className="mr-1 ml-1">
                                                            /
                                                          </span>
                                                        )}
                                                      </>
                                                    );
                                                  })()}
                                                </div>
                                              ));
                                          }
                                        )}
                                      </span>
                                    );
                                  })()
                                }
                              </span>
                              {/* 編輯特口按鈕 */}
                              <div>
                                {/* 當組合不可設定特口 => 隱藏編輯按鈕*/}
                                {(() => {
                                  let whichTaste;
                                  eachCombi.takeout
                                    ? (whichTaste = data.takeoutTaste)
                                    : (whichTaste = data.stayInTaste);
                                  if (
                                    !whichTaste ||
                                    whichTaste.length <= 0 ||
                                    user !== "staff"
                                  )
                                    return null;
                                  return (
                                    <a
                                      className="icn ic_order_edit__mobile"
                                      onClick={() => {
                                        onEditTaste({
                                          specPopupSetting: {
                                            toggle: true,
                                            productName: data.name,
                                            specName: eachSpec.name,
                                            dineInTaste: data.stayInTaste,
                                            takeoutTaste: data.takeoutTaste,
                                            disableTakeoutState: true,
                                          },
                                          // productName: data.name,
                                          // specName:
                                          //   data.specification[specIndex].name,
                                          // itemList: whichTaste,
                                          // selectedItem: eachCombi.taste,
                                          currModify: {
                                            specId: eachSpec.id,
                                            taste: eachCombi.taste,
                                            takeout: eachCombi.takeout,
                                            quantity: eachCombi.quantity,
                                          },
                                        });
                                      }}
                                    />
                                  );
                                })()}
                              </div>
                            </div>
                            <div className="d-flex align-items-center col p-0 pl-4">
                              {/* 內用/外帶 */}
                              <div className="d-flex justify-content-start align-items-center col p-0">
                                <CusSwitch
                                  value={eachCombi.takeout}
                                  //status狀態，1=尚未銷售、2=銷售中、3=本日售畢、4=暫停銷售
                                  //applyMode 是0=皆不適用 1=通用  2=限內用  3=限外帶
                                  disabled={
                                    eachSpec.applyMode !== 1 ||
                                    eachSpec.status === 3 ||
                                    eachSpec.status === 4
                                  }
                                  onClick={() => {
                                    let newState = _.cloneDeep(data);
                                    let targetClone = { ...eachCombi };
                                    let nextTaste = eachCombi.takeout
                                      ? data.stayInTaste
                                      : data.takeoutTaste;
                                    // 當前要轉變的產品 -> 規格 -> 組合的預設特口
                                    let nextDefaultTaste = nextTaste
                                      .filter((def) => def.preset)
                                      .map((e) => e.id);

                                    // 20200318 每次切換時，重選預設特口
                                    // 20221019 移除上面規則
                                    // 當前要轉變的產品 -> 規格 -> 組合的非預設特口
                                    let nextWithoutDefaultTaste = nextTaste
                                      .filter((def) => !def.preset)
                                      .map((e) => e.id);
                                    // 當前組合更變成外帶/內用時 => 輸出原本與非預設特口的交集(已選擇的非預設共用特口)
                                    let checkCanCurrentTaste = _.intersection(
                                      targetClone.taste,
                                      nextWithoutDefaultTaste
                                    );
                                    // 當前組合更變成外帶/內用時 => 輸出合併預設特口與已選擇的非預設共用特口
                                    let concatCheckAndDefault = _.concat(
                                      nextDefaultTaste,
                                      checkCanCurrentTaste
                                    ).sort();
                                    targetClone.taste = concatCheckAndDefault;
                                    targetClone.takeout = !targetClone.takeout;
                                    newState.specification[
                                      specIndex
                                    ].combination[combiIndex] = targetClone;
                                    onUpdate(newState);
                                  }}
                                />
                              </div>
                              {/*鎖菜*/}
                              {globalState.staffInfo.checkOrderData &&
                               globalState.staffInfo.checkOrderData.isAddOrder ? (
                              <div className="mx-2 d-flex">
                                {(() => {
                                  let isCheck;
                                  //  整張單有鎖菜
                                  if (globalState.Hold) {
                                    isCheck = globalState.Hold.holditems.find(
                                      (item) => {
                                        const combination =
                                          data.specification[specIndex]
                                            .combination[combiIndex];
                                        const Data = {
                                          id: data.specification[specIndex].id,
                                          taste: combination.taste,
                                          takeout: combination.takeout,
                                          quantity: combination.quantity,
                                        };

                                        return (
                                          JSON.stringify(
                                            item.productIdcombi
                                          ) === JSON.stringify(Data) &&
                                          item.hold > 0
                                        );
                                      }
                                    );
                                  }
                                  //  單品項有鎖菜
                                  return (
                                    <>
                                      <div className="d-inline-flex align-items-center w-auto">
                                        <label
                                          className={cls(
                                            "CusCheckbox d-flex flex-shrink-0"
                                          )}
                                          onClick={() => {
                                            console.log("herer");
                                            let newState = { ...data };

                                            newState.specification[
                                              specIndex
                                            ].combination[combiIndex].bIsLock =
                                              !eachCombi.bIsLock;

                                            if (eachCombi.bIsLock === false) {
                                              newState.specification[
                                                specIndex
                                              ].combination[
                                                combiIndex
                                              ].lockTime = 0;
                                            }
                                            onUpdate(newState);

                                            const { staffInfo } = globalState;
                                            // {本次輸入的值}
                                            //有沒有組合
                                            const combination =
                                              newState.specification[specIndex]
                                                .combination[combiIndex];
                                            const newHoldItem = {
                                              // productId: data.id,
                                              productIdcombi: {
                                                id: newState.specification[
                                                  specIndex
                                                ].id,
                                                taste: combination.taste,
                                                takeout: combination.takeout,
                                                quantity: combination.quantity,
                                              },
                                              hold: 0,
                                            };
                                            const saveLockTimetoLocal = () => {
                                              if (globalState.Hold) {
                                                let LockTimeItem =
                                                  globalState.Hold.holditems;
                                                //  {新增一筆-----------}
                                                const JsonNewData =
                                                  JSON.stringify(
                                                    newHoldItem.productIdcombi
                                                  );
                                                let data = LockTimeItem.find(
                                                  (x1) => {
                                                    const JsonData =
                                                      JSON.stringify(
                                                        x1.productIdcombi
                                                      );
                                                    return (
                                                      JsonData === JsonNewData
                                                    );
                                                  }
                                                );

                                                if (data) {
                                                  data.hold = 0;
                                                } else {
                                                  LockTimeItem.push(
                                                    newHoldItem
                                                  );
                                                }
                                                dispatchGlobal({
                                                  type: "UPDATE",
                                                  payload: [
                                                    {
                                                      key: "Hold",
                                                      val: {
                                                        orderCode:
                                                          staffInfo.orderCode,
                                                        holditems: LockTimeItem,
                                                      },
                                                    },
                                                  ],
                                                });
                                              } else {
                                                // {換單刷新的時候跑這個------------}
                                                dispatchGlobal({
                                                  type: "UPDATE",
                                                  payload: [
                                                    {
                                                      key: "Hold",
                                                      val: {
                                                        orderCode:
                                                          staffInfo.orderCode,
                                                        holditems: [
                                                          newHoldItem,
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                });
                                              }
                                            };

                                            saveLockTimetoLocal();
                                          }}
                                        >
                                          {eachCombi.quantity>0?eachCombi.bIsLock ||
                                          eachCombi.lockTime > 0 
                                          ? (
                                            <svg viewBox="0 0 10 10">
                                              <path d="M2 5 L4 8 L8 2" />
                                            </svg>
                                          ) : null:null}
                                        </label>
                                        <span className="ml-3 text-justify">
                                          <FormattedMessage id="pages.LockItem" />
                                        </span>
                                      </div>
                                      {eachCombi.bIsLock && eachCombi.quantity>0|| eachCombi.lockTime > 0  ? (
                                        <>
                                          <div className="d-inline-flex align-items-center w-auto">
                                            <div style={{ width: "100px" }}>
                                              <div className="CusInput w-100 d-flex">
                                                {/* {準備撈出鎖菜} */}
                                                <input
                                                  type="tel"
                                                  maxLength={"2"}
                                                  className="p-0 w-100 text-center"
                                                  value={eachCombi.lockTime}
                                                  // disabled={!eachCombi.bIsLock}
                                                  // {輸入框的值}
                                                  onChange={(e) => {
                                                    let newState = { ...data };
                                                    newState.specification[
                                                      specIndex
                                                    ].combination[
                                                      combiIndex
                                                    ].lockTime = e.target.value;

                                                    onUpdate(newState);

                                                    const { staffInfo } =
                                                      globalState;
                                                    // {本次輸入的值}
                                                    //有沒有組合
                                                    const combination =
                                                      newState.specification[
                                                        specIndex
                                                      ].combination[combiIndex];
                                                    const newHoldItem = {
                                                      // productId: data.id,
                                                      productIdcombi: {
                                                        id: newState
                                                          .specification[
                                                          specIndex
                                                        ].id,
                                                        taste:
                                                          combination.taste,
                                                        takeout:
                                                          combination.takeout,
                                                        quantity:
                                                          combination.quantity,
                                                      },
                                                      hold: e.target.value,
                                                    };
                                                    const saveLockTimetoLocal =
                                                      () => {
                                                        if (globalState.Hold) {
                                                          let LockTimeItem =
                                                            globalState.Hold
                                                              .holditems;
                                                          //  {新增一筆-----------}
                                                          const JsonNewData =
                                                            JSON.stringify(
                                                              newHoldItem.productIdcombi
                                                            );

                                                          let data =
                                                            LockTimeItem.find(
                                                              (x1) => {
                                                                const JsonData =
                                                                  JSON.stringify(
                                                                    x1.productIdcombi
                                                                  );
                                                                return (
                                                                  JsonData ===
                                                                  JsonNewData
                                                                );
                                                              }
                                                            );

                                                          if (data) {
                                                            data.hold =
                                                              e.target.value;
                                                          } else {
                                                            LockTimeItem.push(
                                                              newHoldItem
                                                            );
                                                          }
                                                          dispatchGlobal({
                                                            type: "UPDATE",
                                                            payload: [
                                                              {
                                                                key: "Hold",
                                                                val: {
                                                                  orderCode:
                                                                    staffInfo.orderCode,
                                                                  holditems:
                                                                    LockTimeItem,
                                                                },
                                                              },
                                                            ],
                                                          });
                                                        } else {
                                                          // {換單刷新的時候跑這個------------}
                                                          dispatchGlobal({
                                                            type: "UPDATE",
                                                            payload: [
                                                              {
                                                                key: "Hold",
                                                                val: {
                                                                  orderCode:
                                                                    staffInfo.orderCode,
                                                                  holditems: [
                                                                    newHoldItem,
                                                                  ],
                                                                },
                                                              },
                                                            ],
                                                          });
                                                        }
                                                      };

                                                    saveLockTimetoLocal();
                                                  }}
                                                ></input>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="d-inline-flex align-items-center w-auto">
                                            <span className="text-justify">
                                              <FormattedMessage id="pages.Minute" />
                                            </span>
                                          </div>
                                        </>
                                      ) : null}
                                    </>
                                  );
                                })()}
                              </div>
                            ) : null}
                              {/* 計數器 */}
                              <div className="d-flex justify-content-center align-items-center col p-0">
                                <Tool_counter
                                  num={eachCombi.quantity}
                                  onlyRemove={
                                    eachSpec.status === 3 ||
                                    eachSpec.status === 4
                                  }
                                  onChangeNum={(nextNum) => {
                                    let newState = { ...data };
                                    newState.specification[
                                      specIndex
                                    ].combination[combiIndex].quantity =
                                      nextNum;
                                    onUpdate(newState);
                                  }}
                                />
                              </div>
                              {/* 單個組合單價 * 數量 */}
                              <div className="d-flex justify-content-end align-items-center col p-0">
                                <span translate="no" className="txtColorBrown">
                                  ${" "}
                                  {(() => {
                                    let whichTaste;
                                    if (eachCombi.takeout) {
                                      whichTaste = data.takeoutTaste;
                                    } else {
                                      whichTaste = data.stayInTaste;
                                    }
                                    let price = eachSpec.price;
                                    let quantity = eachCombi.quantity;
                                    let tastePrice = eachCombi.taste.map(
                                      (e) => {
                                        let findTaste = whichTaste.find(
                                          (f) => f.id === e
                                        );
                                        return findTaste.price;
                                      }
                                    );
                                    let combiTastePrice = tastePrice.reduce(
                                      (curr, item) => {
                                        return curr + item;
                                      },
                                      0
                                    );
                                    return (
                                      price * quantity +
                                      combiTastePrice * quantity
                                    );
                                  })()}
                                </span>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className=" d-flex justify-content-between align-items-center pt-2 pb-2">
                            <div className="d-flex align-items-center">
                              {/* <div className="d-flex align-items-center" style={{ visibility: `${user === 'staff' ? 'visible' : 'hidden'}` }}> */}
                              {/* 刪除組合按鈕 */}
                              <div>
                                {/* 當組合超過一個的時候 => 顯示刪除按鈕 */}
                                {/* 當售完且數量不為零的時候 => 顯示刪除按紐 */}
                                {(eachSpec.combination.length !== 1 &&
                                  user === "staff") ||
                                ((eachSpec.status === 3 ||
                                  eachSpec.status === 4) &&
                                  eachCombi.quantity !== 0) ? (
                                  <a
                                    className="icn ic_order_remove__mobile"
                                    onClick={() => {
                                      let newState = _.cloneDeep(data);
                                      newState.specification[
                                        specIndex
                                      ].combination.splice(combiIndex, 1);
                                      onDelete({
                                        newData: newState,
                                      });
                                    }}
                                  />
                                ) : null}
                              </div>
                              {/* 顯示特口 */}
                              <span className="pl-2">
                                {/* 當組合不可設定特口 => 隱藏特口顯示*/}
                                <span className="mr-1 d-flex flex-wrap">
                                  {
                                    // 當組合不可設定特口 => 隱藏特口顯示
                                    (() => {
                                      return (
                                        <span className="mr-1 d-flex flex-wrap">
                                          {eachCombi.taste.map(
                                            (taste, tasteIndex) => {
                                              let whichTaste;
                                              if (eachCombi.takeout) {
                                                whichTaste = data.takeoutTaste;
                                              } else {
                                                whichTaste = data.stayInTaste;
                                              }
                                              return whichTaste
                                                .filter((tasteData) => {
                                                  return tasteData.id === taste;
                                                })
                                                .map((e, index) => (
                                                  <div
                                                    key={index}
                                                    className="text-nowrap"
                                                  >
                                                    {(() => {
                                                      let hasPrice =
                                                        e.price > 0;
                                                      let isLast =
                                                        eachCombi.taste
                                                          .length ===
                                                        tasteIndex + 1;
                                                      return (
                                                        <>
                                                          <span>
                                                            {hasPrice
                                                              ? `${e.name}($+${e.price})`
                                                              : `${e.name}`}
                                                          </span>
                                                          {isLast ? (
                                                            ""
                                                          ) : (
                                                            <span className="mr-1 ml-1">
                                                              /
                                                            </span>
                                                          )}
                                                        </>
                                                      );
                                                    })()}
                                                  </div>
                                                ));
                                            }
                                          )}
                                        </span>
                                      );
                                    })()
                                  }
                                </span>
                              </span>
                              {/* 編輯特口按鈕 */}
                              <div>
                                {/* 當組合不可設定特口 => 隱藏編輯按鈕*/}
                                {(() => {
                                  let whichTaste;
                                  eachCombi.takeout
                                    ? (whichTaste = data.takeoutTaste)
                                    : (whichTaste = data.stayInTaste);
                                  if (
                                    !whichTaste ||
                                    whichTaste.length <= 0 ||
                                    user !== "staff"
                                  )
                                    return null;
                                  return (
                                    <a
                                      className="icn ic_order_edit__mobile"
                                      onClick={() => {
                                        onEditTaste({
                                          specPopupSetting: {
                                            toggle: true,
                                            productName: data.name,
                                            specName: eachSpec.name,
                                            dineInTaste: data.stayInTaste,
                                            takeoutTaste: data.takeoutTaste,
                                          },
                                          // productName: data.name,
                                          // specName:
                                          //   data.specification[specIndex].name,
                                          // itemList: whichTaste,
                                          // selectedItem: eachCombi.taste,
                                          currModify: {
                                            specId: eachSpec.id,
                                            taste: eachCombi.taste,
                                            takeout: eachCombi.takeout,
                                            quantity: eachCombi.quantity,
                                          },
                                        });
                                      }}
                                    />
                                  );
                                })()}
                              </div>
                            </div>
                            {/* 計數器 */}
                            <div className="ml-3">
                              <Tool_counter
                                num={eachCombi.quantity}
                                onlyRemove={
                                  eachSpec.status === 3 || eachSpec.status === 4
                                }
                                onChangeNum={(nextNum) => {
                                  let newState = { ...data };
                                  newState.specification[specIndex].combination[
                                    combiIndex
                                  ].quantity = nextNum;
                                  onUpdate(newState);
                                }}
                              />
                            </div>
                          </div>
                          <hr className="m-0" />
                          <div className="d-flex justify-content-between align-items-center pt-2 pb-2">
                            {/* 內用/外帶 */}
                            <div>
                              <CusSwitch
                                value={eachCombi.takeout}
                                disabled={eachSpec.applyMode !== 1}
                                onClick={() => {
                                  let newState = _.cloneDeep(data);
                                  let targetClone = { ...eachCombi };
                                  let nextTaste = eachCombi.takeout
                                    ? data.stayInTaste
                                    : data.takeoutTaste;
                                  // 當前要轉變的產品 -> 規格 -> 組合的預設特口
                                  let nextDefaultTaste = nextTaste
                                    .filter((def) => def.preset)
                                    .map((e) => e.id);
                                  // 當前要轉變的產品 -> 規格 -> 組合的非預設特口
                                  let nextWithoutDefaultTaste = nextTaste
                                    .filter((def) => !def.preset)
                                    .map((e) => e.id);
                                  // 當前組合更變成外帶/內用時 => 輸出原本與非預設特口的交集(已選擇的非預設共用特口)
                                  let checkCanCurrentTaste = _.intersection(
                                    targetClone.taste,
                                    nextWithoutDefaultTaste
                                  );
                                  // 當前組合更變成外帶/內用時 => 輸出合併預設特口與已選擇的非預設共用特口
                                  let concatCheckAndDefault = _.concat(
                                    nextDefaultTaste,
                                    checkCanCurrentTaste
                                  ).sort();
                                  targetClone.taste = concatCheckAndDefault;
                                  targetClone.takeout = !targetClone.takeout;
                                  newState.specification[specIndex].combination[
                                    combiIndex
                                  ] = targetClone;
                                  onUpdate(newState);
                                }}
                              />
                            </div>
                            {/*鎖菜*/}
                           
                            {globalState.staffInfo.checkOrderData &&
                            globalState.staffInfo.checkOrderData.isAddOrder ? (
                              <div className="mx-2 d-flex">
                                {(() => {
                                  let isCheck;
                                  //  整張單有鎖菜
                                  if (globalState.Hold) {
                                    isCheck = globalState.Hold.holditems.find(
                                      (item) => {
                                        const combination =
                                          data.specification[specIndex]
                                            .combination[combiIndex];
                                        const Data = {
                                          id: data.specification[specIndex].id,
                                          taste: combination.taste,
                                          takeout: combination.takeout,
                                          quantity: combination.quantity,
                                        };

                                        return (
                                          JSON.stringify(
                                            item.productIdcombi
                                          ) === JSON.stringify(Data) &&
                                          item.hold > 0
                                        );
                                      }
                                    );
                                  }
                                  //  單品項有鎖菜
                                  return (
                                    <>
                                      <div className="d-inline-flex align-items-center w-auto">
                                        <label
                                          className={cls(
                                            "CusCheckbox d-flex flex-shrink-0"
                                          )}
                                          onClick={() => {
                                            console.log("herer");
                                            let newState = { ...data };

                                            newState.specification[
                                              specIndex
                                            ].combination[combiIndex].bIsLock =
                                              !eachCombi.bIsLock;

                                            if (eachCombi.bIsLock === false) {
                                              newState.specification[
                                                specIndex
                                              ].combination[
                                                combiIndex
                                              ].lockTime = 0;
                                            }
                                            onUpdate(newState);

                                            const { staffInfo } = globalState;
                                            // {本次輸入的值}
                                            //有沒有組合
                                            const combination =
                                              newState.specification[specIndex]
                                                .combination[combiIndex];
                                            const newHoldItem = {
                                              // productId: data.id,
                                              productIdcombi: {
                                                id: newState.specification[
                                                  specIndex
                                                ].id,
                                                taste: combination.taste,
                                                takeout: combination.takeout,
                                                quantity: combination.quantity,
                                              },
                                              hold: 0,
                                            };
                                            const saveLockTimetoLocal = () => {
                                              if (globalState.Hold) {
                                                let LockTimeItem =
                                                  globalState.Hold.holditems;
                                                //  {新增一筆-----------}
                                                const JsonNewData =
                                                  JSON.stringify(
                                                    newHoldItem.productIdcombi
                                                  );

                                                let data = LockTimeItem.find(
                                                  (x1) => {
                                                    const JsonData =
                                                      JSON.stringify(
                                                        x1.productIdcombi
                                                      );
                                                    return (
                                                      JsonData === JsonNewData
                                                    );
                                                  }
                                                );

                                                if (data) {
                                                  data.hold = 0;
                                                } else {
                                                  LockTimeItem.push(
                                                    newHoldItem
                                                  );
                                                }
                                                dispatchGlobal({
                                                  type: "UPDATE",
                                                  payload: [
                                                    {
                                                      key: "Hold",
                                                      val: {
                                                        orderCode:
                                                          staffInfo.orderCode,
                                                        holditems: LockTimeItem,
                                                      },
                                                    },
                                                  ],
                                                });
                                              } else {
                                                // {換單刷新的時候跑這個------------}
                                                dispatchGlobal({
                                                  type: "UPDATE",
                                                  payload: [
                                                    {
                                                      key: "Hold",
                                                      val: {
                                                        orderCode:
                                                          staffInfo.orderCode,
                                                        holditems: [
                                                          newHoldItem,
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                });
                                              }
                                            };

                                            saveLockTimetoLocal();
                                          }}
                                        >                                                                                                                   
                                          {eachCombi.quantity>0?eachCombi.bIsLock ||
                                          eachCombi.lockTime > 0 
                                          ? (
                                            <svg viewBox="0 0 10 10">
                                              <path d="M2 5 L4 8 L8 2" />
                                            </svg>
                                          ) : null:null}
                                        </label>
                                        <span className="ml-3 text-justify">
                                          <FormattedMessage id="pages.LockItem" />
                                        </span>
                                      </div>
                                      {eachCombi.bIsLock && eachCombi.quantity>0|| eachCombi.lockTime > 0  ? (
                                        <>
                                          <div className="d-inline-flex align-items-center w-auto">
                                            <div style={{ width: "100px" }}>
                                              <div className="CusInput w-100 d-flex">
                                                {/* {準備撈出鎖菜} */}
                                                <input
                                                  type="tel"
                                                  maxLength={"2"}
                                                  className="p-0 w-100 text-center"
                                                  value={eachCombi.lockTime}
                                                  // disabled={!eachCombi.bIsLock}
                                                  // {輸入框的值}
                                                  onChange={(e) => {
                                                    let newState = { ...data };
                                                    newState.specification[
                                                      specIndex
                                                    ].combination[
                                                      combiIndex
                                                    ].lockTime = e.target.value;

                                                    onUpdate(newState);

                                                    const { staffInfo } =
                                                      globalState;
                                                    // {本次輸入的值}
                                                    //有沒有組合
                                                    const combination =
                                                      newState.specification[
                                                        specIndex
                                                      ].combination[combiIndex];
                                                    const newHoldItem = {
                                                      // productId: data.id,
                                                      productIdcombi: {
                                                        id: newState
                                                          .specification[
                                                          specIndex
                                                        ].id,
                                                        taste:
                                                          combination.taste,
                                                        takeout:
                                                          combination.takeout,
                                                        quantity:
                                                          combination.quantity,
                                                      },
                                                      hold: e.target.value,
                                                    };
                                                    const saveLockTimetoLocal =
                                                      () => {
                                                        if (globalState.Hold) {
                                                          let LockTimeItem =
                                                            globalState.Hold
                                                              .holditems;
                                                          //  {新增一筆-----------}
                                                          const JsonNewData =
                                                            JSON.stringify(
                                                              newHoldItem.productIdcombi
                                                            );

                                                          let data =
                                                            LockTimeItem.find(
                                                              (x1) => {
                                                                const JsonData =
                                                                  JSON.stringify(
                                                                    x1.productIdcombi
                                                                  );
                                                                return (
                                                                  JsonData ===
                                                                  JsonNewData
                                                                );
                                                              }
                                                            );

                                                          if (data) {
                                                            data.hold =
                                                              e.target.value;
                                                          } else {
                                                            LockTimeItem.push(
                                                              newHoldItem
                                                            );
                                                          }
                                                          dispatchGlobal({
                                                            type: "UPDATE",
                                                            payload: [
                                                              {
                                                                key: "Hold",
                                                                val: {
                                                                  orderCode:
                                                                    staffInfo.orderCode,
                                                                  holditems:
                                                                    LockTimeItem,
                                                                },
                                                              },
                                                            ],
                                                          });
                                                        } else {
                                                          // {換單刷新的時候跑這個------------}
                                                          dispatchGlobal({
                                                            type: "UPDATE",
                                                            payload: [
                                                              {
                                                                key: "Hold",
                                                                val: {
                                                                  orderCode:
                                                                    staffInfo.orderCode,
                                                                  holditems: [
                                                                    newHoldItem,
                                                                  ],
                                                                },
                                                              },
                                                            ],
                                                          });
                                                        }
                                                      };

                                                    saveLockTimetoLocal();
                                                  }}
                                                ></input>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="d-inline-flex align-items-center w-auto">
                                            <span className="text-justify">
                                              <FormattedMessage id="pages.Minute" />
                                            </span>
                                          </div>
                                        </>
                                      ) : null}
                                    </>
                                  );
                                })()}
                              </div>
                            ) : null}
                            {/* 單個組合單價 * 數量 */}
                            <div>
                              <span translate="no" className="txtColorBrown">
                                ${" "}
                                {(() => {
                                  let whichTaste;
                                  if (eachCombi.takeout) {
                                    whichTaste = data.takeoutTaste;
                                  } else {
                                    whichTaste = data.stayInTaste;
                                  }
                                  let price = eachSpec.price;
                                  let quantity = eachCombi.quantity;
                                  let tastePrice = eachCombi.taste.map((e) => {
                                    let findTaste = whichTaste.find(
                                      (f) => f.id === e
                                    );
                                    return findTaste.price;
                                  });
                                  let combiTastePrice = tastePrice.reduce(
                                    (curr, item) => {
                                      return curr + item;
                                    },
                                    0
                                  );
                                  return (
                                    price * quantity +
                                    combiTastePrice * quantity
                                  );
                                })()}
                              </span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </>
            ))
          }
        </div>
      ))}
    </div>
  );
}

export default Tool_mealListWithoutSplit_staff;
